import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=7dfd1efe&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=7dfd1efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfd1efe",
  null
  
)

export default component.exports